import MyConsults from '../myconsults/myconsults';

export function DashBoard() {
  return <MyConsults consults={[]} />;
}
